<template>
    <div>
      <info v-if="type==='1'" :center-id="centerId" @typeChange="type='2'"></info>
      <center-info v-else @change="centerIdChange"></center-info>
    </div>
</template>

<script>
  import Info from './register/Info'
  import CenterInfo from './register/Center'
  import {  mapGetters } from 'vuex'
  export default {
    name: 'Register',
    components: { Info,CenterInfo },
    data(){
      return {
        type:'1',
        centerId:'',
      }
    },
    mounted(){
      this.centerIdChange(this.userInfo().centerId)
      // console.log(this.centerId,this.userInfo())
    },
    methods:{
      ...mapGetters(["userInfo"]),
      centerIdChange(centerId){
        this.centerId = centerId
        this.type='1'
      }
    }
  }
</script>

<style scoped>

</style>